import { render, staticRenderFns } from "./upAndDown.vue?vue&type=template&id=5cf0679a&scoped=true&"
import script from "./upAndDown.vue?vue&type=script&lang=js&"
export * from "./upAndDown.vue?vue&type=script&lang=js&"
import style0 from "./upAndDown.vue?vue&type=style&index=0&id=5cf0679a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf0679a",
  null
  
)

export default component.exports